import React from "react";
import styles from "./index.module.scss";
import { Button } from "components/buttons/Button";

interface PassEmptyStateProps {
    title?: string;
    message: string;
    linkText: string;
    onClick: () => void;
}

const PassEmptyState: React.FC<PassEmptyStateProps> = ({
    title,
    message,
    linkText,
    onClick
}) => {
    return (
        <div
            className={`empty-pass-container ${styles["empty-pass-container"]}`}
        >
            {title && <h5 className={styles["empty-pass-title"]}>{title}</h5>}
            <p className={styles["empty-pass-description"]}>{message}</p>

            <Button onClick={onClick}>{linkText}</Button>
        </div>
    );
};

export default PassEmptyState;
